import { JUNE_NAME as NAME, JUNE_DISPLAY_NAME as DISPLAY_NAME } from '../../constants/Destinations';

const DIR_NAME = 'June';

const CNameMapping = {
  [NAME]: NAME,
  June: NAME,
  june: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME, DIR_NAME };
